module.exports = __webpack_public_path__ + "static/media/notebook-grey.db675d4f.svg";